/**
 * External dependencies
 */
import {registerPlugin} from '@wordpress/plugins';
import {ExperimentalDiscountsMeta} from '@woocommerce/blocks-checkout';
import parse from "html-react-parser";

const RemovePartialPayments = () => {

    return (
        <div className="wc-block-components-totals-wrapper">
            <div className="wc-block-components-totals-item">
                <span className="wc-block-components-totals-item__label">{ywf_remove_partial_payments.label}</span>
                <span
                    className="wc-block-formatted-money-amount wc-block-components-formatted-money-amount wc-block-components-totals-item__value">
                        <a href={ywf_remove_partial_payments.callback_url}>
                        -{parse(ywf_remove_partial_payments.funds_used)}
                        </a>
                    </span>
            </div>
        </div>
    )
};
const render = () => {
    return (
        <>
            <ExperimentalDiscountsMeta context='woocommerce/checkout'>
                <RemovePartialPayments/>
            </ExperimentalDiscountsMeta>
        </>
    );
};

registerPlugin('yith-funds-remove-partial-payments-on-block', {
    render,
    scope: 'woocommerce-checkout',
});